import type { ReactNode } from 'react'

/**
 * Paylaşılan salt-okuma etiket-değer listesi (013 tasarım dili — FR-010). Detay ekranlarında meta
 * bilgileri tutarlı ızgarada gösterir. Reuse Mandate.
 */
export interface DetailItem {
  label: string
  value: ReactNode
}

export interface DetailListProps {
  items: DetailItem[]
}

export default function DetailList({ items }: Readonly<DetailListProps>) {
  return (
    <dl className="ui-detail-list">
      {items.map((it, i) => (
        <div className="ui-detail-row" key={i}>
          <dt className="ui-detail-label">{it.label}</dt>
          <dd className="ui-detail-value">{it.value ?? ''}</dd>
        </div>
      ))}
    </dl>
  )
}
